import { Controller } from 'stimulus'
import { useBusItem } from '../mixins/useBusItem.js'

export default class extends Controller {
  static targets = ['resultsCounter', 'resultsSelectedCounter']

  static values = {
    busItemId: String,
    resultsCount: String,

    // This will be needed later, just defining it for now so we can remember the logic for this counter
    //  should remain on this controller.
    resultsSelectedCount: Number
  }

  resultsCountValueChanged() {
    if (this.hasResultsCountValue) {
      this.resultsCounterTarget.innerHTML = this.numberWithCommas(this.resultsCountValue)
    }
  }

  connect() {
    console.log('connected')
    useBusItem(this)
  }

  disconnect() {
    this.removeFromBus()
  }

  setResultsCount(event) {
    const newValue = event.detail[Object.keys(event.detail)[0]]
    this.resultsCountValue = newValue
  }

  // PRIVATE
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
}
